import InnerViewArea from './InnerViewArea';

export default InnerViewArea;
